<template>
	<gc-dialog
		title="专用报警配置"
		width="1300px"
		:show.sync="visible"
		:ok-loading="loading"
		@close="handleCancelClick"
		@ok="handleConfirmClick"
	>
		<div class="content-wrapper">
			<div class="content-left">
				<p class="list-title">
					<i></i>
					<span>水表台账</span>
				</p>
				<div class="area-tree">
					<el-tree
						ref="treeRef"
						:data="areaTree"
						:props="propsObj"
						highlight-current
						default-expand-all
						node-key="code"
						:current-node-key="currentNodeKey"
						@node-click="handleNodeClick"
					>
						<template #default="{ node }">
							<span class="custom-tree-node" :class="{ disabled: isDisabled(node) }">
								{{ node.label }}
							</span>
						</template>
					</el-tree>
				</div>
			</div>
			<div class="content-right">
				<TableArea
					ref="tableRef"
					:event-id="data.id"
					:show-comparison-name="showComparisonName"
					:visible="visible"
					:water-region-code="currentNodeKey"
				/>
			</div>
		</div>
		<template #footer>
			<el-button type="primary" @click="handleConfirmClick">保存</el-button>
		</template>
	</gc-dialog>
</template>

<script>
import { apiGetWaterAreaTree, apiCreateSpecialAlarmConfig } from '@/apis/waterAlarmConfig.api'
import { conditionalOptionObj } from '@/config/validate'
import { isValidate } from '@/utils/validate'
import TableArea from './table-area/index.vue'

export default {
	name: 'DedicatedAlarmDialog',
	inject: ['getComparison'],
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Object,
			default: () => ({}),
		},
		showComparisonName: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		TableArea,
	},
	data() {
		return {
			propsObj: { label: 'name', children: 'children' },
			areaTree: [],
			visible: false,
			loading: false,
			currentNodeKey: null,
			event: {},
		}
	},
	watch: {
		show: {
			handler(val) {
				this.visible = val
				if (!val) {
					return
				}
				this.$nextTick(() => {
					const code = this.$store.state.user.userInfo.defaultWaterRegionCode

					this.tenantType == 1 && this.$set(this.params, 'waterRegionCode', code)
					this.currentNodeKey = code
					this.$refs.treeRef.setCurrentKey(code)
				})
			},
		},
	},
	computed: {
		comparison() {
			// DedicatedAlarm组件provide
			return this.getComparison()
		},
	},
	mounted() {
		this.updateAreaTree()
	},
	methods: {
		async updateAreaTree() {
			const staffId = this.$store.getters.userInfo.staffId
			this.areaTree = await this.getAreaTree({ staffId })
		},
		handleNodeClick(data) {
			this.currentNodeKey = data.code
		},
		handleConfirmClick() {
			const data = this.$refs.tableRef.getData()

			if (!this.isValid(data)) {
				return
			}
			const params = this.generateParams(data, this.data, this.showComparisonName)
			this.createData(params)
		},
		handleCancelClick() {
			this.$emit('update:show', false)
		},
		getAreaTree(params) {
			return apiGetWaterAreaTree(params)
				.then(res => res)
				.catch(() => [])
		},
		isValid(data) {
			if (data.selectedRows.length < 1) {
				this.$message.warning('请至少勾选一个设备')
				return false
			}
			if (this.showComparisonName && !data.duration) {
				this.$message.warning(`请填写${this.comparison.comparisonName}`)
				return false
			}
			const timeVerificationRule = {
				type: this.comparison.eventExpression.conditionalStatementId,
				value: Number(this.comparison.eventExpression.comparisonValue),
			}
			if (this.showComparisonName && !isValidate(timeVerificationRule, Number(data.duration))) {
				this.$message.warning(this.generateMessage(timeVerificationRule))
				return false
			}
			return true
		},
		generateMessage(rule) {
			switch (rule.type) {
				case conditionalOptionObj.equal:
					return `${this.comparison.comparisonName}必须等于 ${rule.value}`
				case conditionalOptionObj.greater:
					return `${this.comparison.comparisonName}必须大于 ${rule.value}`
				case conditionalOptionObj.less:
					return `${this.comparison.comparisonName}必须小于 ${rule.value}`
				default:
					return `${this.comparison.comparisonName}校验出错`
			}
		},
		isDisabled({ data }) {
			return data?.unSelectFlag === 1
		},
		generateParams(data, { id: eventId, name: eventName }, showComparisonName) {
			return {
				eventId,
				eventName,
				pushCreateBIds: data.pushCreateBIds?.join(',') ?? '',
				comparisonValue: showComparisonName ? data.duration : undefined,
				eventLevel: data.level,
				waterSpecialAlarmConfig: data.selectedRows.map(item => ({
					deviceId: item.deviceId,
					deviceNo: item.deviceNo,
					designNo: item.designNo,
					waterRegionCode: item.waterRegionCode,
					userTypeId: item.userType,
					userNo: item.userNo,
					userName: item.username,
					deviceTypeId: item.deviceTypeId,
					dynamicContent: item.dynamicContent,
				})),
			}
		},
		createData(params) {
			apiCreateSpecialAlarmConfig(params)
				.then(() => {
					this.$message.success('保存成功')
					this.$emit('success')
				})
				.catch(() => {})
				.finally(() => {
					this.$emit('update:show', false)
				})
		},
	},
}
</script>

<style scoped lang="scss">
::v-deep .el-tree-node__content {
	min-height: 42px;
	border-radius: 4px;
	.el-icon-caret-right:not(.is-leaf) {
		color: #3f435e;
		font-size: 12px;
		font-weight: bold;
	}
}

.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	width: 0;
	height: 100%;
	color: #3f435e;
	line-height: 22px;
	height: 100%;
	&.disabled {
		opacity: 0.5;
		//pointer-events: none;
		cursor: not-allowed;

		span {
			cursor: not-allowed;
		}
	}
}
.el-tree {
	width: fit-content;
	min-width: 100%;
	height: 100%;
}

.content-wrapper {
	display: flex;
	gap: 10px;
	height: 600px;
	overflow: hidden;
}

.content-left {
	flex: 0 0 240px;
	display: flex;
	flex-direction: column;
	border-right: 1px solid #e6e6e6;
	overflow: hidden;
}

.area-tree {
	max-height: 600px;
	flex: 1;
	padding-right: 10px;
	overflow: auto;
}

.content-right {
	flex: 1;
	min-width: 0;
}

.list-title {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	font-size: 16px;
	font-weight: bold;
	color: #333;
	i {
		width: 4px;
		height: 16px;
		background: #4474cf;
		margin-right: 8px;
	}
}
</style>
